import { createContext, Context } from 'react';

import { INavContext } from './interfaces';

export const navContext: Context<INavContext> = createContext({} as INavContext);
